// extracted by mini-css-extract-plugin
module.exports = {"container":"Download_container__otJ3A","size":"Download_size__WJNlf","button":"Download_button__Pnjz7"};